import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TwoPagePdfViewer } from "../TwoPagePdfViewer/TwoPagePdfViewer";

const PublicUploadPreviewDialog = ({ file, onCancel, onConfirm }) => {
  const { t } = useTranslation("publicPortal");
  const isPdf = file.fileType === "application/pdf";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-publicPortal-overlay p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={t("verification.previewTitle")}
    >
      <div className="relative flex max-h-[92vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-cfSecondary shadow-xl">
        <div className="flex items-center justify-between border-b border-cfCardBorder px-5 py-4 sm:px-7">
          <div className="min-w-0 pr-4">
            <h2 className="m-0 text-xl font-bold text-cfHeadingText">
              {t("verification.previewTitle")}
            </h2>
            <p className="m-0 mt-1 truncate text-xs text-cfGlobalText">
              {file.fileName}
            </p>
          </div>
          <button
            type="button"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cfSearchContainer text-cfGlobalText"
            onClick={onCancel}
            aria-label={t("verification.close")}
          >
            <X aria-hidden="true" size={20} />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-auto p-4 sm:p-6">
          {isPdf ? (
            <TwoPagePdfViewer
              pdfUrl={file.document}
              showZoom
              heightClassName="max-h-[65vh]"
            />
          ) : (
            <img
              className="mx-auto max-h-[65vh] w-full object-contain"
              src={file.document}
              alt={t("verification.previewAlt")}
            />
          )}
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-cfCardBorder px-5 py-4 sm:flex-row sm:justify-end sm:px-7">
          <button
            type="button"
            className="rounded-[8px] border border-cfCardBorder bg-cfSecondary px-5 py-3 text-sm font-semibold text-cfCardTagText"
            onClick={onCancel}
          >
            {t("verification.cancel")}
          </button>
          <button
            type="button"
            className="rounded-[8px] bg-cfPrimary px-5 py-3 text-sm font-semibold text-publicPortal-onBrand transition hover:bg-cfPrimaryDark"
            onClick={onConfirm}
          >
            {t("verification.verifyUpload")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublicUploadPreviewDialog;
